import React, { useState } from "react";
import AgentInsuranceDoc from "./AccountBodyDocument/AgentInsuranceDoc";
import MiscellaneousDoc from "./AccountBodyDocument/MiscellaneousDoc";
import AgentVisaDoc from "./AccountBodyDocument/AgentVisaDoc";
import AgentMainClients from "./AgentMainClients";
import AgentClientsEnquiry from "./AgentClientsEnquiry";
import Border from "./../../assets/images/border.png";

const AgentMainBody = (props) => {
  const [checkimage, setcheckimage] = useState("clients");
  // const loggedInUser = localStorage.getItem("agentLogin");
  //console.log('Agent Login:',loggedInUser);

  return (
    <div className="accountbody">
      <div className="accountbody_tabnav_outer">
        <ul className="nav nav-tabs accountbody_tabnav">
          <li className="nav-item row mx-0 ">
            <a
              className="nav-link active"
              data-toggle="tab"
              href="#clients"
              onClick={() => setcheckimage("clients")}
            >
              Clients
            </a>
            {checkimage === "clients" || checkimage === "application" ? null : (
              <img alt="border" src={Border} />
            )}
          </li>
          <li className="nav-item row mx-0 ">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#enquiry"
              onClick={() => setcheckimage("application")}
            >
              Applications
            </a>
            {checkimage === "application" || checkimage === "visa" ? null : (
              <img alt="border" src={Border} />
            )}
          </li>
          <li className="nav-item row mx-0">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#visa"
              onClick={() => setcheckimage("visa")}
            >
              Visa Application
            </a>
            {checkimage === "visa" || checkimage === "insurance" ? null : (
              <img alt="border" src={Border} />
            )}
          </li>
          <li className="nav-item row mx-0">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#insurance"
              onClick={() => setcheckimage("insurance")}
            >
              Insurance
            </a>
            {checkimage === "insurance" || checkimage === "miss" ? null : (
              <img alt="border" src={Border} />
            )}
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              data-toggle="tab"
              href="#miscellaneous"
              onClick={() => setcheckimage("miss")}
            >
              Miscellaneous
            </a>
          </li>
        </ul>
      </div>
      <div className="tab-content">
        <div id="clients" className=" tab-pane active">
          <AgentMainClients />
        </div>
        <div id="enquiry" className=" tab-pane active">
          <AgentClientsEnquiry />
        </div>
        {/* <div id="document" className=" tab-pane fade">
          <DocumentDoc />
        </div> */}
        {/* <div id="enrollment" className="tab-pane fade">
          <AccountEnrollment />
        </div> */}
        <div id="visa" className=" tab-pane fade">
          <AgentVisaDoc />
        </div>
        <div id="insurance" className=" tab-pane fade">
          <AgentInsuranceDoc />
        </div>
        <div id="miscellaneous" className=" tab-pane fade">
          <MiscellaneousDoc />
        </div>
      </div>
    </div>
  );
};

export default AgentMainBody;
